import { Flex, Text } from '@chakra-ui/layout';
import { Divider } from '@chakra-ui/react';
import CardMy from 'components/CardMy';
import ChangePassword from './items/ChangePassword';
import MainInfo from './items/MainInfo';
import UserAvatar from './items/UserAvatar';
import { useAppSelector } from 'store/hooks';
import { selectMe } from 'store/slices/user';

const AccountSettings = () => {
    const { firstName, lastName } = useAppSelector(selectMe);

    return (
        <CardMy>
            <Flex flexDirection="column" gap="32px">
                <Text color="gray.900" fontSize="24px" fontWeight={700} lineHeight={1} letterSpacing="-0.48px">
                    Personal Information
                </Text>
                <UserAvatar name={`${firstName || ''} ${lastName || ''}`} />
                <MainInfo />
                <Divider color="gray.200" opacity={1} />
                <ChangePassword />
            </Flex>
        </CardMy>
    );
};

export default AccountSettings;
